import registerBasicData from './registerBasicData';
import '../../moment/moment-and-timezone-init';
import '../../moment/standardMomentLocales';
import { RegisterableIntlProvider } from '../../internal/hs-intl';

export default (Provider: RegisterableIntlProvider) => {
  return registerBasicData(Provider);
};
